import React from 'react';

import { FormattedMessage, useIntl } from 'react-intl';

import FieldDropdownIcon from '@atlaskit/icon/core/field-dropdown';
import LinkIcon from '@atlaskit/icon/core/link';
import { ButtonItem, MenuGroup } from '@atlaskit/menu';
// eslint-disable-next-line @atlaskit/design-system/no-emotion-primitives -- to be migrated to @atlaskit/primitives/compiled – go/akcss
import { Flex, xcss } from '@atlaskit/primitives';
import Tooltip from '@atlaskit/tooltip';

import { ITEM } from '../../../../../types';

import i18n from './messages';

const menuGroupStyles = xcss({
	width: '300px',
});

export type NewItemSelectionProps = {
	isAddMenuSubItemDisabled?: boolean;
	setIsConfiguring: (isConfiguring: boolean) => void;
	setNewItemType: (newItemType: ITEM | undefined) => void;
};

export const NewItemSelection = ({
	setIsConfiguring,
	setNewItemType,
	isAddMenuSubItemDisabled = false,
}: NewItemSelectionProps): React.JSX.Element => {
	const intl = useIntl();

	const handleAddLinkClick = () => {
		setIsConfiguring(true);
		setNewItemType(ITEM.LINK);
	};

	const handleAddMenuClick = () => {
		setIsConfiguring(true);
		setNewItemType(ITEM.MENU);
	};

	return (
		<Flex xcss={menuGroupStyles}>
			<MenuGroup minWidth="100%">
				<ButtonItem
					iconBefore={<LinkIcon label="" />}
					description={intl.formatMessage(i18n.addLinkButtonDescription)}
					onClick={handleAddLinkClick}
				>
					<FormattedMessage {...i18n.addLinkButtonText} />
				</ButtonItem>
				<Tooltip
					content={<FormattedMessage {...i18n.menuSubItemCreationDisabledTooltipText} />}
					canAppear={() => isAddMenuSubItemDisabled}
				>
					<ButtonItem
						isDisabled={isAddMenuSubItemDisabled}
						iconBefore={<FieldDropdownIcon label="" />}
						description={intl.formatMessage(i18n.addMenuButtonDescription)}
						onClick={handleAddMenuClick}
					>
						<FormattedMessage {...i18n.addMenuButtonText} />
					</ButtonItem>
				</Tooltip>
			</MenuGroup>
		</Flex>
	);
};
